module.exports = __webpack_public_path__ + "static/media/mockup@2x.647a440f.png";